module.exports = __webpack_public_path__ + "img/yassir.4c02b606.png";